export default {"src":"/_next/static/media/download.a2823ed8.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};